import React, { Fragment, useState, useEffect } from "react";
import { Field, reduxForm } from 'redux-form';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, TabContent, TabPane, Nav, NavItem, NavLink, Table } from 'reactstrap';
import classnames from 'classnames';
import moment from 'moment';
import renderSelectField from '../../../../shared/components/form/Select';
import TimetableIcon from 'mdi-react/TimetableIcon';
import renderRadioButtonField from '../../../../shared/components/form/RadioButton';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import PercentField from './PercentField';
import SpecialtyApi from '../../api/specialty_api';
import ThirdsApi from '../../api/thirds_api';
import AlertModal from '../../../../shared/components/Modal';
import ClinicalStudioApi from '../../api/clinical_studio_api';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import CompanyApi from '../../api/company_api';
import Modal from '@material-ui/core/Modal';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },
    },
});


const CreateClinicalStudio = ({ history, location }) => {
    //----------------------------HTML----------------------------------------/
    //Tabulador
    const [activeTab, setActiveTab] = useState('1');
    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    //Alerta Modal
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    const okModal = () => {
        setAlerShowModal(false);
        if (colorAlertModal == "success" && finish == true && idEstudio != null) {
            let feasibilityState = location.state;
            feasibilityState.id_estudio = idEstudio;
            let _url = "/clinical-studio/show-clinical-studio";
            if (window.location.pathname === process.env.PUBLIC_URL + _url) {
                history.replace(process.env.PUBLIC_URL + "/");
                setTimeout(() => {
                    history.replace({
                        pathname: process.env.PUBLIC_URL + _url,
                        state: feasibilityState
                    });
                }, 0);
            } else {
                history.push({
                    pathname: process.env.PUBLIC_URL + _url,
                    state: feasibilityState,
                });
            }
        }
    }


    //------------------------DATOS FACTIBILIDAD---------------------------------------/
    const [date, setDate] = React.useState(moment(location.state.fecha).format('YYYY/MM/DD'));
    const [dateStudio, setDateStudio] = React.useState(moment().format('YYYY/MM/DD'));
    const [sponsorName, setSponsorName] = React.useState(location.state.nombre_tercero);
    const [sponsorId, setSponsorId] = React.useState(location.state.id_tercero);
    const [studyName, setStudyName] = React.useState(location.state.nombre);
    const [acronym, setAcronym] = React.useState(location.state.acronimo);
    const [contact, setContact] = React.useState(location.state.contacto);
    const [email, setEmail] = React.useState(location.state.mail);
    //------------------------DATOS BASICOS---------------------------------------/
    const [categoryOpt, setCategoryOpt] = React.useState(
        [
            { value: 1, label: "Investigacion Riesgo Minimo" },
            { value: 2, label: "Investigaciones con Riesgo Mayor que el Minimo" }
        ]
    );
    const [numProtocol, setNumProtocol] = React.useState(null);
    const [studyTypeOpt, setStudyTypeOpt] = React.useState( //Tipos de Estudio
        [
            { value: 1, label: "Observacional" },
            { value: 2, label: "Experimental" },
            { value: 3, label: "Bioequivalencia" }
        ]
    );
    const [studyType, setStudyType] = React.useState(1);

    const [category, setCategory] = React.useState(1);
    const [specialtyOpt, setSpecialtyOpt] = React.useState( //Especialidades (Desde Base de Datos)
        [
        ]
    );
    const [specialty, setSpecialty] = React.useState(1);
    const [dateLegContract, setDateLegContract] = React.useState(null);
    const [costCenter, setCostCenter] = React.useState(null);
    const [siteNumber, setSiteNumber] = React.useState(null);
    const [transporterOpt, setTransporterOpt] = React.useState( //Transportador
        [
            { value: 1, label: "No Requiere" },
            { value: 2, label: "Ocasa" },
            { value: 3, label: "Dhl" },
            { value: 4, label: "Marken" },
        ]
    );
    const [transporter, setTransporter] = React.useState(1);
    //------------------------CRO---------------------------------------/
    const [croOpt, setCroOpt] = React.useState([{ value: '1', label: "CRO 1" }, { value: '2', label: "CRO 2" }]);
    const [cro, setCro] = React.useState(null);
    const [croList, setCroList] = React.useState([]);
    //------------------------CENTRO---------------------------------------/
    const [datePersonCenter, setDatePersonCenter] = React.useState(null);
    const [doVisitStarter, setDoVisitStarter] = React.useState(true);
    const [commentVisitCenter, setCommentVisitCenter] = React.useState(null);
    const [dateVisitStarterCenter, setDateVisitStarterCenter] = React.useState(null);
    const [dateRecruitmentStarterCenter, setDateRecruitmentStarterCenter] = React.useState(null);
    const [dateRecruitmentFinishCenter, setDateRecruitmentFinishCenter] = React.useState(null);
    const [dateVisitPatientFinish, setDateVisitPatientFinish] = React.useState(null);
    const [dateCloseHarvestData, setDateCloseHarvestData] = React.useState(null);
    const [dateFinalStudio, setDateFinalStudio] = React.useState(null);
    const [dateWorldStarter, setDateWorldStarter] = React.useState(null);
    const [dateWorldClose, setDateWorldClose] = React.useState(null);
    //------------------------Resumen---------------------------------------/
    const [approveInvima, setApproveInvima] = React.useState(true);
    const [forbiddenMedicine, setForbidenMedicine] = React.useState(false);
    const [selectMemberArterialPresion, setSelectMemberArterialPresion] = React.useState(true);
    const [numberPatientsSponsor, setNumberPatientsSponsor] = React.useState(null);
    const [numberPatientsCenter, setNumberPatientsCenter] = React.useState(null);
    const [numberRandomVisits, setNumberRandomVisits] = React.useState(null);
    const [timeTotalStudioMonths, setTimeTotalStudioMonths] = React.useState(null);
    const [stateStudio, setStateStudio] = React.useState(1);
    const [stateStudioOpt, setStateStudioOpt] = React.useState(
        [
            { value: 1, label: "Regulatorio" },
            { value: 2, label: "En Curso" },
            { value: 3, label: "Finalizado" }
        ]
    );
    const [retentionVisitsPercent, setRetentionVisitsPercent] = React.useState(null);
    const [generalExpendsPercent, setGeneralExpendsPercent] = React.useState(null);

    //------------------------POLIZA DE RESPONSABILIDAD---------------------------------------/
    const [liabityPolicyRequire, setLiabityPolicyRequire] = React.useState(true);
    const [idPolicyLiability, setIdPolicyLiability] = React.useState(0);//Lista de Compañias Aseguradora
    const [listCompanys, setListCompanys] = React.useState([]);//Lista de Compañias Aseguradora
    const [companyPolicy, setCompanyPolicy] = React.useState(null);//Compañia Aseguradora
    const [numPolicy, setNumPolicy] = React.useState(null);//Numero de Poliza
    const [dateStartPolicy, setDateStartPolicy] = React.useState(null);//Fecha Inicial de la Poliza (Vigencia)
    const [dateFinalPolicy, setDateFinalPolicy] = React.useState(null);//Fecha Final de la Poliza (Vigencia)
    const [documentPolicy, setDocumentPolicy] = React.useState(null);//Documento de la Poliza
    const [listPolicyLiability, setListPolicyLiability] = React.useState([]);//Lista de Polizas

    const [deletePolicyIds, setDeletePolicyIds] = React.useState([]);//Lista de Polizas para Eliminar

    //------------------------ESTUDIO CLINICO---------------------------------------/
    const [actionFetch, setActionFetch] = React.useState(1);
    const [idEstudio, setIdEstudio] = React.useState(null);
    const [finish, setFinish] = React.useState(false);

    //------------------------LOADER---------------------------------------/
    const [isLoading, setIsLoading] = React.useState(false);


    //------------------------ACCIONES---------------------------------------/
    const validate = () => {

        //Validar Tab de Factibilidad
        if (
            studyName == "" || studyName == null
            /*
            || acronym == null || acronym == ""
            || contact == null || contact == "" 
            || email == null || email == ""
             || dateStudio == null || sponsorId == null*/
        ) {
            alertModal(false, "Hay campos pendientes obligatorios en la Pestaña de Factibilidad");
            return;
        }
        else if (
            numProtocol == null || numProtocol == '' || studyType == null ||
            category == null ||
            specialty == null ||
            dateLegContract == null || dateLegContract == "" ||
            costCenter == null || costCenter == "" ||
            siteNumber == null || siteNumber == "" ||
            transporter == null
        ) {
            alertModal(false, "Hay campos pendientes obligatorios en la Pestaña de Datos Basicos");
            return;
        }
        else if (
            datePersonCenter == null || datePersonCenter == ""
        ) {
            alertModal(false, "Hay campos pendientes obligatorios en la Pestaña de Centro");
            return;
        }

        else if (
            approveInvima == null
            || forbiddenMedicine == null
            || selectMemberArterialPresion == null
            || numberPatientsSponsor == null || numberPatientsSponsor == ""
            || numberPatientsCenter == null || numberPatientsCenter == ""
            || numberRandomVisits == null || numberRandomVisits == ""
            || timeTotalStudioMonths == null || timeTotalStudioMonths == ""
            || stateStudio == null || stateStudio == ""
            || retentionVisitsPercent == null || retentionVisitsPercent == ""
            || generalExpendsPercent == null || generalExpendsPercent == ""
            || liabityPolicyRequire == null
        ) {
            alertModal(false, "Hay campos pendientes obligatorios en la Pestaña de Resumen");
            return;
        }
        else {
            saveClinicalStudio();
        }
    }

    const listSpecialties = async () => {
        let specialtyList = await SpecialtyApi.listSpecialties();
        setSpecialtyOpt(specialtyList);
        setSpecialty(parseInt(specialtyList[0].id_especialidad));
    }

    const listCROs = async () => {
        let crosList = await ThirdsApi.listCROs();
        setCroOpt(crosList);
    }

    const saveClinicalStudio = async () => {
        setIsLoading(true);
        try {
            //Validacion de Poliza

            let listadoDePolizas = [];
            if (liabityPolicyRequire == true) {
                listadoDePolizas = listPolicyLiability;
            }

            let crosListJSON = {
                cros: croList
            }

            var dataClinicalStudio = new FormData();
            dataClinicalStudio.append("nombre", studyName);
            dataClinicalStudio.append("id_tercero", location.state.id_tercero);
            dataClinicalStudio.append("acro", location.state.acronimo);
            dataClinicalStudio.append("id_factibilidad", location.state.id_factibilidad);
            dataClinicalStudio.append("contacto", location.state.contacto);
            dataClinicalStudio.append("mail", location.state.mail);
            dataClinicalStudio.append("num_protocolo", numProtocol);
            dataClinicalStudio.append("tipo_estudio", studyType);
            dataClinicalStudio.append("categoria", category);
            dataClinicalStudio.append("especialidad", specialty);
            dataClinicalStudio.append("fecha_legal_contrato", dateLegContract != "" ? moment(dateLegContract).format('YYYY-MM-DD') : null);
            dataClinicalStudio.append("centro_costos", costCenter);
            dataClinicalStudio.append("numero_sitio", siteNumber);
            dataClinicalStudio.append("transportador", transporter);
            dataClinicalStudio.append("cros", JSON.stringify(crosListJSON));
            dataClinicalStudio.append("fecha_primer_suje_enrrolado", datePersonCenter != "" ? moment(datePersonCenter).format('YYYY-MM-DD') : null);
            dataClinicalStudio.append("visita_inicio", doVisitStarter);
            dataClinicalStudio.append("comentario", commentVisitCenter);
            dataClinicalStudio.append("fecha_visita_inicio", dateVisitStarterCenter != null ? moment(dateVisitStarterCenter).format('YYYY-MM-DD') : null);
            dataClinicalStudio.append("fecha_inicio_reclutamiento", dateRecruitmentStarterCenter != null ? moment(dateRecruitmentStarterCenter).format('YYYY-MM-DD') : null);
            dataClinicalStudio.append("fecha_final_reclutamiento", dateRecruitmentFinishCenter != null ? moment(dateRecruitmentFinishCenter).format('YYYY-MM-DD') : null);
            dataClinicalStudio.append("fecha_ultima_visita_ultimo_pac", dateVisitPatientFinish != null ? moment(dateVisitPatientFinish).format('YYYY-MM-DD') : null);
            dataClinicalStudio.append("fecha_cierre_recoleccion_datos", dateCloseHarvestData != null ? moment(dateCloseHarvestData).format('YYYY-MM-DD') : null);
            dataClinicalStudio.append("fecha_final_estudio", dateFinalStudio != null ? moment(dateFinalStudio).format('YYYY-MM-DD') : null);
            dataClinicalStudio.append("fecha_inicio_mundial", dateWorldStarter != null ? moment(dateWorldStarter).format('YYYY-MM-DD') : null);
            dataClinicalStudio.append("fecha_cierre_mundial", dateWorldClose != null ? moment(dateWorldClose).format('YYYY-MM-DD') : null);
            dataClinicalStudio.append("requiere_apro_invima", approveInvima);
            dataClinicalStudio.append("medic_prohibidos", forbiddenMedicine);
            dataClinicalStudio.append("sel_miembro_toma_tension", selectMemberArterialPresion);
            dataClinicalStudio.append("num_pac_patrocinador", numberPatientsSponsor);
            dataClinicalStudio.append("num_pac_centro", numberPatientsCenter);
            dataClinicalStudio.append("cantidad_visitas", 0);
            dataClinicalStudio.append("num_visitas_aleatorizacion", numberRandomVisits);
            dataClinicalStudio.append("tiempo_total_estudio", timeTotalStudioMonths);
            dataClinicalStudio.append("estado_estudio", stateStudio);
            dataClinicalStudio.append("porc_retencion_visitas", retentionVisitsPercent);
            dataClinicalStudio.append("porc_gastos_generales", generalExpendsPercent);
            dataClinicalStudio.append("plan_tarifario", null);
            dataClinicalStudio.append("requiere_poliza_responsabilidad", liabityPolicyRequire);



            if (actionFetch == 1) {//Crear
                let data = await ClinicalStudioApi.createClinicalStudio(dataClinicalStudio);
                if (data != null) {
                    let policySaved = await submitPolicyClinicalStudio(data.estudio.estudio.id_estudio);

                    if (policySaved == true) {
                        setIsLoading(false);
                        setIdEstudio(data.estudio.estudio.id_estudio);
                        setFinish(true);
                        alertModal(true, "Estudio Clinico Generado Exitosamente");
                    }
                    else {
                        setIsLoading(false);
                        alertModal(false, "Ha ocurrido un error en el servidor");
                    }

                }
                else {
                    setIsLoading(false);
                    alertModal(false, "Ha ocurrido un error en el servidor");
                }
            }
            else//Actualizar
            {
                dataClinicalStudio.append("id_estudio", idEstudio);

                //Elimina primero los Registros Anteriores de las Polizas
                if (deletePolicyIds.length > 0) { //Eliminar Polizas Existentes
                    for (var i = 0; i < deletePolicyIds.length; i++) {
                        let policyDeleteData =
                        {
                            id_poliza: deletePolicyIds[i].id_poliza,
                            nombre_archivo: deletePolicyIds[i].archivo,
                            id_estudio: location.state.id_estudio
                        }
                        await ClinicalStudioApi.deletePolicy(policyDeleteData);
                    }
                }

                let data = await ClinicalStudioApi.updateClinicalStudio(dataClinicalStudio);
                if (data != null) {
                    let policySaved = await submitPolicyClinicalStudio(data.estudio.estudio.id_estudio);

                    if (policySaved == true) {
                        setIsLoading(false);
                        setIdEstudio(data.estudio.estudio.id_estudio);
                        setFinish(true);
                        alertModal(true, "Estudio Clinico Actualizado Exitosamente");
                    }
                    else {
                        setIsLoading(false);
                        alertModal(false, "Ha ocurrido un error en el servidor");
                    }

                }
                else {
                    setIsLoading(false);
                    alertModal(false, "Ha ocurrido un error en el servidor");
                }
            }
        }
        catch (error) {
            setIsLoading(false);
            alertModal(false, "Ha ocurrido un error en el servidor");
        }
    }

    const submitPolicyClinicalStudio = async (id_estudio) => {
        let policySaved = true;
        for (let i = 0; i < listPolicyLiability.length; i++) {
            if (listPolicyLiability[i].id_poliza == null || listPolicyLiability[i].id_poliza == undefined) {//Si no esta en Base de Datos, se guarda
                var dataPolicy = new FormData();
                dataPolicy.append("company", listPolicyLiability[i].company);
                dataPolicy.append("num_policy", listPolicyLiability[i].num_policy);
                dataPolicy.append("date_start_policy", listPolicyLiability[i].date_start_policy);
                dataPolicy.append("date_final_policy", listPolicyLiability[i].date_final_policy);
                dataPolicy.append("documentPolicy", listPolicyLiability[i].documentPolicy);
                dataPolicy.append("documentName", listPolicyLiability[i].documentName);
                dataPolicy.append("urlDocument", listPolicyLiability[i].urlDocument);
                dataPolicy.append("id_estudioc", id_estudio);
                let policy = await ClinicalStudioApi.addPolicy(dataPolicy);

                if (policy == null) {
                    policySaved = false;
                    break;
                }
            }
        }
        return policySaved;
    }

    const handleChangeCROSelect = (value) => {
        setCro(value);
    }

    const addCRO = () => {
        if (cro != null) {
            let repetido = false;
            let newList = [];

            if (croList.length > 0) {
                for (let i = 0; i < croList.length; i++) {
                    newList.push(croList[i]);
                    if (croList[i].id_tercero == cro.id_tercero) {
                        repetido = true;
                    }
                }
            }

            if (repetido == false) {
                let newCro =
                {
                    id_tercero: cro.id_tercero,
                    nit: cro.nit,
                    codigosgsss: cro.codigosgsss,
                    nombre: cro.nombre,
                    correo: cro.correo
                }
                newList.push(newCro);
            }

            setCroList(newList);
        }
    }

    const removeCRO = (cro_remove) => {
        if (croList.length > 0) {
            let newList = [];
            for (let i = 0; i < croList.length; i++) {
                if (croList[i].id_tercero != cro_remove.id_tercero) {
                    newList.push(croList[i]);
                }
            }
            setCroList(newList);
        }
    }

    const listLiabilityCompanies = async () => {
        let companyList = await CompanyApi.listCompanies();

        if (companyList != null) {
            setListCompanys(companyList.contenido);
        }
        else {
            setListCompanys([]);
        }
    }

    const handleSubmitLiabilityPolicy = () => {
        try {

            //Validaciones 
            if (companyPolicy == null) {
                alertModal(false, "Debe seleccionar una compañia aseguradora");
                return;
            }

            if (numPolicy == null) {
                alertModal(false, "Debe ingresar el número de Poliza");
                return;
            }

            if (dateStartPolicy == null) {
                alertModal(false, "Debe seleccionar la fecha inicial de la vigencia de la Poliza");
                return;
            }

            if (dateFinalPolicy == null) {
                alertModal(false, "Debe seleccionar la fecha final de la vigencia de la Poliza");
                return;
            }

            if (documentPolicy == null) {
                alertModal(false, "Debe adjuntar el documento de la poliza");
                return;
            }


            let liabilityPolicyList = [];

            let cont = idPolicyLiability + 1;

            for (let i = 0; i < listPolicyLiability.length; i++) {
                liabilityPolicyList.push(listPolicyLiability[i]);
            }

            let liabilityPolicy =
            {
                id_poliza: null,
                temp_id: cont,
                company: companyPolicy != null ? companyPolicy.nombre : null,
                num_policy: numPolicy != null ? numPolicy : null,
                date_start_policy: dateStartPolicy != null ? moment(dateStartPolicy).format('YYYY/MM/DD') : null,
                date_final_policy: dateFinalPolicy != null ? moment(dateFinalPolicy).format('YYYY/MM/DD') : null,
                documentPolicy: documentPolicy != null ? documentPolicy : null,
                documentName: documentPolicy != null ? documentPolicy.name : "",
                urlDocument: documentPolicy != null ? URL.createObjectURL(documentPolicy) : "#"
            }

            liabilityPolicyList.push(liabilityPolicy);
            setIdPolicyLiability(cont);
            setListPolicyLiability(liabilityPolicyList);
        }
        catch (err) {
            console.log(err);
        }
    }

    const removePolicyLiability = (policyLiabilityRemove) => {
        if (listPolicyLiability.length > 0) {
            let newList = [];
            for (let i = 0; i < listPolicyLiability.length; i++) {
                if (listPolicyLiability[i].temp_id != policyLiabilityRemove.temp_id) {
                    newList.push(listPolicyLiability[i]);
                }
                else {
                    if (listPolicyLiability[i].id_poliza != undefined && listPolicyLiability[i].id_poliza != null)//Si es una Poliza existente
                    {
                        console.log(deletePolicyIds);
                        let listPolicyDelete = [];
                        for (let d = 0; d < deletePolicyIds.length; d++) {
                            let polizaParaEliminar =
                            {
                                id_poliza: deletePolicyIds[d].id_poliza,
                                archivo: deletePolicyIds[d].archivo,
                            }
                            listPolicyDelete.push(polizaParaEliminar);
                        }

                        let policyDelete =
                        {
                            id_poliza: listPolicyLiability[i].id_poliza,
                            archivo: listPolicyLiability[i].documentName,
                        }

                        listPolicyDelete.push(policyDelete);
                        setDeletePolicyIds(listPolicyDelete);
                    }
                }
            }
            setListPolicyLiability(newList);
        }
    }

    const existClinicalStudio = (id_estudio) => {
        if (id_estudio != null)//Actualizar
        {
            setActionFetch(2);
            showDataClinicalStudio(id_estudio);
        }
        else //Crear
        {
            setActionFetch(1);
        }
    }

    //Si el Estudio Clinico existe, consulta los Datos Respectivos
    const showDataClinicalStudio = async (id_estudio) => {
        try {
            setIsLoading(true);
            let estudioClinico = await ClinicalStudioApi.showClinicalStudio(id_estudio);

            if (estudioClinico.existe == true) {

                setIdEstudio(id_estudio);
                let estudio = estudioClinico.contenido;

                //Factibilidad
                setStudyName(estudio.estudio.nombre);
                setDate(estudio.factibilidad.fecha);
                setDateStudio(estudio.estudio.fecha);
                setSponsorName(estudio.factibilidad.nombre_tercero);
                setSponsorId(estudio.factibilidad.id_tercero);
                setAcronym(estudio.factibilidad.acronimo);
                setContact(estudio.factibilidad.contacto);
                setEmail(estudio.factibilidad.mail);

                //Datos Basicos
                setNumProtocol(estudio.detalles.num_protocolo);
                setStudyType(parseInt(estudio.detalles.tipo_estudio));
                setCategory(parseInt(estudio.detalles.categoria));
                setSpecialty(parseInt(estudio.detalles.especialidad));
                setDateLegContract(estudio.detalles.fecha_legal_contrato != null ? new Date(estudio.detalles.fecha_legal_contrato) : null);
                setCostCenter(estudio.detalles.centro_costos);
                setSiteNumber(estudio.detalles.numero_sitio);
                setTransporter(parseInt(estudio.detalles.transportador));

                //CRO
                let newListCro = [];
                for (let i = 0; i < estudio.detalles.cros.cros.length; i++) {
                    let newCro =
                    {
                        id_tercero: estudio.detalles.cros.cros[i].id_tercero,
                        nit: estudio.detalles.cros.cros[i].nit,
                        codigosgsss: estudio.detalles.cros.cros[i].codigosgsss,
                        nombre: estudio.detalles.cros.cros[i].nombre,
                        correo: estudio.detalles.cros.cros[i].correo
                    }
                    newListCro.push(newCro);
                    setCroList(newListCro);
                }

                //Centro
                setDatePersonCenter(estudio.detalles.fecha_primer_suje_enrrolado);
                setDoVisitStarter(estudio.detalles.visita_inicio);
                setCommentVisitCenter(estudio.detalles.comentario)
                setDateVisitStarterCenter(estudio.detalles.fecha_visita_inicio != null ? new Date(estudio.detalles.fecha_visita_inicio) : null);
                setDateRecruitmentStarterCenter(estudio.detalles.fecha_inicio_reclutamiento != null ? new Date(estudio.detalles.fecha_inicio_reclutamiento) : null);
                setDateRecruitmentFinishCenter(estudio.detalles.fecha_final_reclutamiento != null ? new Date(estudio.detalles.fecha_final_reclutamiento) : null);
                setDateVisitPatientFinish(estudio.detalles.fecha_ultima_visita_ultimo_pac != null ? new Date(estudio.detalles.fecha_ultima_visita_ultimo_pac) : null);
                setDateCloseHarvestData(estudio.detalles.fecha_cierre_recoleccion_datos != null ? new Date(estudio.detalles.fecha_cierre_recoleccion_datos) : null);
                setDateFinalStudio(estudio.detalles.fecha_final_estudio != null ? new Date(estudio.detalles.fecha_final_estudio) : null);
                setDateWorldStarter(estudio.detalles.fecha_inicio_mundial != null ? new Date(estudio.detalles.fecha_inicio_mundial) : null);
                setDateWorldClose(estudio.detalles.fecha_cierre_mundial != null ? new Date(estudio.detalles.fecha_cierre_mundial) : null);

                //Resumen
                setApproveInvima(estudio.detalles.requiere_apro_invima);
                setForbidenMedicine(estudio.detalles.medic_prohibidos);
                setSelectMemberArterialPresion(estudio.detalles.sel_miembro_toma_tension);
                setNumberPatientsSponsor(parseInt(estudio.detalles.num_pac_patrocinador));
                setNumberPatientsCenter(parseInt(estudio.detalles.num_pac_centro));
                setNumberRandomVisits(parseInt(estudio.detalles.num_visitas_aleatorizacion));
                setTimeTotalStudioMonths(parseInt(estudio.detalles.tiempo_total_estudio));
                setRetentionVisitsPercent(parseInt(estudio.detalles.porc_retencion_visitas));
                setGeneralExpendsPercent(parseInt(estudio.detalles.porc_gastos_generales));
                setStateStudio(parseInt(estudio.detalles.estado_estudio));

                //Poliza de Responsabilidad
                setLiabityPolicyRequire(estudio.detalles.requiere_poliza_responsabilidad);
                verifyPolicyStudio(estudio.polizas, estudio.estudio.id_estudio);
                setIsLoading(false);
            }
            else {
                throw new Error("Ha ocurrido cargando los datos del Estudio Clinico");
            }
        }
        catch (e) {
            setIsLoading(false);
            alertModal(false, "Ha ocurrido cargando los datos del Estudio Clinico");
        }
    }

    const verifyPolicyStudio = async (polizas, id_estudio) => {
        let liabilityPolicyList = [];
        let cont = idPolicyLiability;
        for (let i = 0; i < polizas.length; i++) {
            cont = cont + 1;
            let liabilityPolicy =
            {
                id_poliza: polizas[i].id_poliza,
                temp_id: cont,
                company: polizas[i].compania,
                num_policy: polizas[i].num_poliza,
                date_start_policy: moment(polizas[i].fecha_inicial).format('YYYY/MM/DD'),
                date_final_policy: moment(polizas[i].fecha_final).format('YYYY/MM/DD'),
                documentPolicy: null,
                documentName: polizas[i].url_archivo,
                urlDocument: process.env.REACT_APP_PUBLIC_URL + "estudiosc/" + id_estudio + "/show_file/" + polizas[i].url_archivo + "/" + sessionStorage.getItem('token')
            }

            liabilityPolicyList.push(liabilityPolicy);
            setIdPolicyLiability(cont);
        }

        setListPolicyLiability(liabilityPolicyList);
    }

    const regresar = () => {
        let _url = "/clinical-studio/dashboard";
        history.push({
            pathname: process.env.PUBLIC_URL + _url,
            state: location.state
        });
    }

    useEffect(() => {
        listSpecialties();
        listCROs();
        listLiabilityCompanies();
        existClinicalStudio(location.state.id_estudio);
    }, []);

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">
                        Estudio Clinico
                        <br />
                        {location.state.nombre_tercero} ({location.state.acronimo})
                    </h3>

                    <Col md={2}>
                        <div className='top_info_buttons_hc'>
                            <div>
                                <Tooltip
                                    title="Regresar al Dashboard"
                                >
                                    <IconButton
                                        aria-label="upload picture"
                                        component="span"
                                        className='tooltip-top'
                                        onClick={() => {
                                            regresar();
                                        }}
                                    >
                                        <ArrowBackIcon style={{ color: '#153365' }} />
                                    </IconButton>
                                </Tooltip>
                                <span style={{ marginLeft: '0.25em' }}>Regresar al Dashboard</span>
                            </div>
                        </div>
                    </Col>
                </Col>
            </Row>
            <div>
                <Card>
                    <CardBody>
                        <div className="tabs tabs--justify tabs--bordered-top">
                            <div className="tabs__wrap">
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => toggle('1')}
                                        >
                                            Factibilidad
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => toggle('2')}
                                        >
                                            Datos Basicos
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '3' })}
                                            onClick={() => toggle('3')}
                                        >
                                            CRO
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '4' })}
                                            onClick={() => toggle('4')}
                                        >
                                            Centro
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '5' })}
                                            onClick={() => toggle('5')}
                                        >
                                            Resumen
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '6' })}
                                            onClick={() => toggle('6')}
                                        >
                                            Poliza de Responsabilidad
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <Container>
                                            <Row className='form form_vertical'>
                                                <Col md={12}>
                                                    <div className="card__title">
                                                        <h5 className="bold-text">Factibilidad</h5>
                                                    </div>
                                                </Col>
                                                <Col md={12}>
                                                    <div className="form__form-group">
                                                        <span className="form__form-group-label">Nombre del Estudio</span>
                                                        <div className="form__form-group-field">
                                                            <textarea value={studyName} onChange={({ target: { value } }) => setStudyName(value)} required={true}>
                                                            </textarea>
                                                        </div>
                                                        {studyName == "" ? <b className="text-danger">El Nombre del Estudio es Requerido</b> : null}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form__form-group">
                                                        <span className="form__form-group-label">Acronimo</span>
                                                        <div className="form__form-group-field">
                                                            <input type="text" value={acronym} disabled={true}
                                                                onChange={({ target: { value } }) => setAcronym(value)} required={true} />
                                                        </div>
                                                        {/*acronym == "" ? <b className="text-danger">El Acronimo es Requerido</b> : null*/}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form__form-group">
                                                        <span className="form__form-group-label">Contacto</span>
                                                        <div className="form__form-group-field">
                                                            <input type="text" value={contact} disabled={true}
                                                                onChange={({ target: { value } }) => setContact(value)} required={true} />
                                                        </div>
                                                        {
                                                            /*{contact == "" ? <b className="text-danger">El Contacto es Requerido</b> : null} */
                                                        }

                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form__form-group">
                                                        <span className="form__form-group-label">Fecha de la Factibilidad</span>
                                                        <div className="form__form-group-field">
                                                            <input type="text" disabled={true} value={date}
                                                                onChange={({ target: { value } }) => setDate(value)} required={true} />
                                                        </div>
                                                        {/*
                                                        date == "" || date == null ? <b className="text-danger">La Fecha de Factibilidad es requerida</b> : null
                                                        */}

                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form__form-group">
                                                        <span className="form__form-group-label">Correo</span>
                                                        <div className="form__form-group-field">
                                                            <input type="text" value={email} disabled={true}
                                                                onChange={({ target: { value } }) => setEmail(value)} required={true} />
                                                        </div>
                                                        {/*email == "" ? <b className="text-danger">El Correo es Requerido</b> : null*/}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form__form-group">
                                                        <span className="form__form-group-label">Fecha de Creación</span>
                                                        <div className="form__form-group-field">
                                                            <input type="text" value={dateStudio} disabled={true}
                                                                onChange={({ target: { value } }) => setDateStudio(value)} />
                                                        </div>
                                                        {/*dateStudio == "" || dateStudio == null ? <b className="text-danger">La fecha de creación es requerida</b> : null*/}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form__form-group">
                                                        <span className="form__form-group-label">Patrocinador</span>
                                                        <div className="form__form-group-field">
                                                            <input type="text" value={sponsorName} disabled={true}
                                                                onChange={({ target: { value } }) => setSponsorName(value)} required={true} />
                                                            {/*sponsorId == "" ? <b className="text-danger">El Patrocinador es Requerido</b> : null*/}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                        </Container>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Container>
                                            <Row>
                                                <Col md={12}>
                                                    <h5 className="bold-text">Datos Basicos</h5>
                                                    <br />
                                                </Col>
                                                <Col md={3}>
                                                    <TextField
                                                        id="numero_protocolo_field"
                                                        label="Número de Protocolo"
                                                        value={numProtocol}
                                                        type="number"
                                                        className='medical-material-form__field'
                                                        onChange={(event) => {
                                                            setNumProtocol(event.target.value);
                                                        }}
                                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                                    >
                                                    </TextField>
                                                    {numProtocol == "" ? <b className="text-danger">El Número de Protocolo es Requerido</b> : null}
                                                </Col>
                                                <Col md={3}>
                                                    <TextField
                                                        id="select_tipo_estudio"
                                                        label="Tipo de Estudio"
                                                        select
                                                        value={studyType}
                                                        className='medical-material-form__field'
                                                        onChange={(event) => {
                                                            setStudyType(event.target.value);
                                                        }}

                                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                                    >
                                                        {studyTypeOpt.map((tpe) => {
                                                            return <MenuItem key={tpe.value} value={tpe.value}>
                                                                {tpe.label}
                                                            </MenuItem>
                                                        })}
                                                    </TextField>
                                                    {studyType == "" || studyType == null ? <b className="text-danger">El Tipo de Estudio es Requerido</b> : null}
                                                </Col>
                                                <Col md={3}>
                                                    <TextField
                                                        id="select_category"
                                                        select
                                                        label="Categoria"
                                                        value={category}
                                                        placeholder="Categoria"
                                                        className='medical-material-form__field'
                                                        onChange={(event) => {
                                                            setCategory(event.target.value);
                                                        }}
                                                        style={{ minWidth: '300px', maxWidth: '100%', borderColor: 'black' }}
                                                    >

                                                        {categoryOpt.map((cat) => {
                                                            return <MenuItem key={cat.value} value={cat.value}>
                                                                {cat.label}
                                                            </MenuItem>
                                                        })}
                                                    </TextField>
                                                    {category == "" || category == null ? <b className="text-danger">La Categoria del Estudio es Requerida</b> : null}
                                                </Col>
                                                <Col md={3}>
                                                    <TextField
                                                        id="select_specialty"
                                                        select
                                                        label="Especialidad"
                                                        value={specialty}
                                                        placeholder="Especialidad"
                                                        className='medical-material-form__field'
                                                        onChange={(event) => {
                                                            setSpecialty(event.target.value);
                                                        }}
                                                        style={{ minWidth: '300px', maxWidth: '100%', borderColor: 'black' }}
                                                    >
                                                        {specialtyOpt.map((spec) => {
                                                            return <MenuItem key={spec.id_especialidad} value={spec.id_especialidad}>
                                                                {spec.especialidad}
                                                            </MenuItem>
                                                        })}
                                                    </TextField>
                                                    {specialty == null ? <b className="text-danger">La Especialidad del Estudio es Requerida</b> : null}
                                                </Col>
                                                <Col md={3}>
                                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <ThemeProvider theme={defaultMaterialTheme}>
                                                            <KeyboardDatePicker
                                                                value={dateLegContract}
                                                                variant="inline"
                                                                onChange={(date) => {
                                                                    if (date == null) {
                                                                        setDateLegContract("");
                                                                    } else {
                                                                        setDateLegContract(date);
                                                                    }
                                                                }}
                                                                helperText={dateLegContract == "" ? 'La Fecha de Legalización de Contrato del Estudio es Requerida' : null}
                                                                label="Fecha de Legalización de Contrato"
                                                                format="yyyy/MM/DD"
                                                                animateYearScrolling
                                                                className='medical-material-form__field material-form__label'
                                                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                                            />
                                                        </ThemeProvider>
                                                    </MuiPickersUtilsProvider>
                                                </Col>



                                                <br />
                                                <br />
                                                <br />
                                                <Col md={3}>

                                                    <TextField
                                                        id="field_centro_costos"
                                                        label="Centro de Costos"

                                                        value={costCenter}
                                                        type="text"
                                                        className='medical-material-form__field'
                                                        onChange={(event) => {
                                                            setCostCenter(event.target.value);
                                                        }}

                                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                                    >
                                                    </TextField>
                                                    {costCenter == "" ? <b className="text-danger">El Centro de Costos es Requerido</b> : null}
                                                </Col>


                                                <Col md={3}>
                                                    <TextField
                                                        id="field_num_sitios"
                                                        label="Número de Sitio"

                                                        value={siteNumber}
                                                        type="number"
                                                        className='medical-material-form__field'
                                                        onChange={(event) => {
                                                            setSiteNumber(event.target.value);
                                                        }}

                                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                                    >
                                                    </TextField>
                                                    {siteNumber == "" ? <b className="text-danger">El Número de Sitios es Requerido</b> : null}
                                                </Col>
                                                <Col md={3}>
                                                    <TextField
                                                        id="select_transporter"
                                                        select
                                                        label="Transportador"
                                                        value={transporter}
                                                        placeholder="Transportador"
                                                        className='medical-material-form__field'
                                                        onChange={(event) => {
                                                            setTransporter(event.target.value);
                                                        }}
                                                        style={{ minWidth: '300px', maxWidth: '100%', borderColor: 'black' }}
                                                    >
                                                        {transporterOpt.map((opttransporter) => {
                                                            return <MenuItem key={opttransporter.value} value={opttransporter.value}>
                                                                {opttransporter.label}
                                                            </MenuItem>
                                                        })}
                                                    </TextField>
                                                    {transporter == null ? <b className="text-danger">El Transportador es Requerido</b> : null}
                                                </Col>

                                            </Row>
                                        </Container>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <Container>
                                            <Container>
                                                <Row>
                                                    <Col md={12}>
                                                        <div className="card__title">
                                                            <h5 className="bold-text">CRO</h5>
                                                        </div>
                                                    </Col>
                                                    <Col md={1}></Col>
                                                    <Col md={9}>
                                                        <TextField
                                                            id="select_cro"
                                                            select
                                                            label="CRO"
                                                            value={cro}
                                                            className='medical-material-form__field'
                                                            onChange={(event) => {
                                                                handleChangeCROSelect(event.target.value);
                                                            }}

                                                            style={{ minWidth: '300px', maxWidth: '100%' }}
                                                        >
                                                            {croOpt.map((croop) => {
                                                                return <MenuItem key={croop.id_tercero} value={croop}>
                                                                    {croop.nombre}
                                                                </MenuItem>
                                                            })}
                                                        </TextField>
                                                    </Col>
                                                    <Col md={1}>
                                                        <br />
                                                        <Button className="btn btn-success btn-sm text-white" onClick={addCRO}>
                                                            +
                                                        </Button>
                                                    </Col>
                                                    <Col md={1}></Col>
                                                    <Col md={12}>
                                                        <Table>
                                                            <thead>
                                                                <tr>
                                                                    <th>Id Tercero</th>
                                                                    <th>Nombre</th>
                                                                    <th>NIT</th>
                                                                    <th>Codigo SGSSS</th>
                                                                    <th>Acción</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {croList.map((croop) => {
                                                                    return <tr>
                                                                        <th>{croop.id_tercero}</th>
                                                                        <td>{croop.nombre}</td>
                                                                        <td>{croop.nit}</td>
                                                                        <td>{croop.codigosgsss}</td>
                                                                        <td>
                                                                            <IconButton
                                                                                onClick={() => {
                                                                                    removeCRO(croop);
                                                                                }}
                                                                            >
                                                                                <FontAwesomeIcon style={{ fontSize: 15 }} icon={faTrashAlt} />
                                                                            </IconButton>
                                                                        </td>
                                                                    </tr>
                                                                })}
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </Container>
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                        </Container>
                                    </TabPane>
                                    <TabPane tabId="4">
                                        <Container>
                                            <Row>
                                                <Col md={12}>
                                                    <div className="card__title">
                                                        <h5 className="bold-text">Centro</h5>
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <ThemeProvider theme={defaultMaterialTheme}>
                                                            <KeyboardDatePicker
                                                                variant="inline"
                                                                value={datePersonCenter}
                                                                onChange={(date) => {
                                                                    if (date == null) {
                                                                        setDatePersonCenter("");
                                                                    }
                                                                    else {
                                                                        setDatePersonCenter(date);
                                                                    }
                                                                }}
                                                                helperText={datePersonCenter == "" ? "La fecha de primer sujeto enrolado en Centro es Requerido" : null}
                                                                label="Fecha primer sujeto enrolado en Centro"
                                                                format="yyyy/MM/DD"
                                                                animateYearScrolling
                                                                className='medical-material-form__field material-form__label'
                                                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                                            />
                                                        </ThemeProvider>
                                                    </MuiPickersUtilsProvider>
                                                </Col>
                                                <Col md={2}>
                                                    <div className="form__form-group">
                                                        <span className="form__form-group-label">Se realizo visita de Inicio</span>
                                                        <div className="form__form-group-field">
                                                            <div className="form__form-group-field">
                                                                <Field
                                                                    name="realizo_visita_inicio"
                                                                    component={renderRadioButtonField}
                                                                    label="Si"
                                                                    radioValue={true}
                                                                    defaultChecked={doVisitStarter == true ? true : false}
                                                                    value={doVisitStarter}
                                                                    onChange={(e) => {
                                                                        setDoVisitStarter(true)
                                                                    }}
                                                                />
                                                                <Field
                                                                    name="realizo_visita_inicio"
                                                                    component={renderRadioButtonField}
                                                                    label="No"
                                                                    defaultChecked={doVisitStarter == false ? true : false}
                                                                    radioValue={false}
                                                                    value={doVisitStarter}
                                                                    onChange={(e) => {
                                                                        setDoVisitStarter(false)
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="form form_vertical">
                                                        <div className="form__form-group">
                                                            <span className="form__form-group-label">Comentario de Visita Centro</span>
                                                            <div className="form__form-group-field">
                                                                <textarea value={commentVisitCenter} onChange={({ target: { value } }) => setCommentVisitCenter(value)} required={true}>
                                                                </textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <ThemeProvider theme={defaultMaterialTheme}>
                                                            <KeyboardDatePicker
                                                                variant="inline"
                                                                value={dateVisitStarterCenter}
                                                                onChange={(date) => {
                                                                    setDateVisitStarterCenter(date);
                                                                }}
                                                                label="Fecha de Visita inicio en el centro"
                                                                format="yyyy/MM/DD"
                                                                animateYearScrolling
                                                                className='medical-material-form__field material-form__label'
                                                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                                            />
                                                        </ThemeProvider>
                                                    </MuiPickersUtilsProvider>
                                                </Col>
                                                <Col md={4}>


                                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <ThemeProvider theme={defaultMaterialTheme}>
                                                            <KeyboardDatePicker
                                                                variant="inline"
                                                                value={dateRecruitmentStarterCenter}
                                                                onChange={(date) => {
                                                                    setDateRecruitmentStarterCenter(date);
                                                                }}
                                                                label="Fecha de Inicio de Reclutamiento en centro"
                                                                format="yyyy/MM/DD"
                                                                animateYearScrolling
                                                                className='medical-material-form__field material-form__label'
                                                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                                            />
                                                        </ThemeProvider>

                                                    </MuiPickersUtilsProvider>
                                                </Col>
                                                <Col md={4}>
                                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <ThemeProvider theme={defaultMaterialTheme}>
                                                            <KeyboardDatePicker
                                                                variant="inline"
                                                                value={dateRecruitmentFinishCenter}
                                                                onChange={(date) => {
                                                                    setDateRecruitmentFinishCenter(date);
                                                                }}
                                                                label="Fecha Final de Reclutamiento en centro"
                                                                format="yyyy/MM/DD"
                                                                animateYearScrolling
                                                                className='medical-material-form__field material-form__label'
                                                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                                            />
                                                        </ThemeProvider>
                                                    </MuiPickersUtilsProvider>
                                                </Col>
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <Col md={4}>
                                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <ThemeProvider theme={defaultMaterialTheme}>
                                                            <KeyboardDatePicker
                                                                variant="inline"
                                                                value={dateVisitPatientFinish}
                                                                onChange={(date) => {
                                                                    setDateVisitPatientFinish(date);
                                                                }}
                                                                label="Fecha ultima visita ultimo paciente centro"
                                                                format="yyyy/MM/DD"
                                                                animateYearScrolling
                                                                className='medical-material-form__field material-form__label'
                                                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                                            />
                                                        </ThemeProvider>

                                                    </MuiPickersUtilsProvider>
                                                </Col>
                                                <Col md={4}>
                                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <ThemeProvider theme={defaultMaterialTheme}>
                                                            <KeyboardDatePicker
                                                                variant="inline"
                                                                value={dateCloseHarvestData}
                                                                onChange={(date) => {
                                                                    setDateCloseHarvestData(date);
                                                                }}
                                                                label="Fecha de Cierre recolección de datos"
                                                                format="yyyy/MM/DD"
                                                                animateYearScrolling
                                                                className='medical-material-form__field material-form__label'
                                                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                                            />
                                                        </ThemeProvider>
                                                    </MuiPickersUtilsProvider>
                                                </Col>
                                                <Col md={4}>
                                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <ThemeProvider theme={defaultMaterialTheme}>
                                                            <KeyboardDatePicker
                                                                variant="inline"
                                                                value={dateFinalStudio}
                                                                onChange={(date) => {
                                                                    setDateFinalStudio(date);
                                                                }}
                                                                label="Fecha final del Estudio"
                                                                format="yyyy/MM/DD"
                                                                animateYearScrolling
                                                                className='medical-material-form__field material-form__label'
                                                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                                            />
                                                        </ThemeProvider>
                                                    </MuiPickersUtilsProvider>
                                                </Col>
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <Col md={4}>
                                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <ThemeProvider theme={defaultMaterialTheme}>
                                                            <KeyboardDatePicker
                                                                variant="inline"
                                                                value={dateWorldStarter}
                                                                onChange={(date) => {
                                                                    setDateWorldStarter(date);
                                                                }}
                                                                label="Fecha de Inicio Mundial"
                                                                format="yyyy/MM/DD"
                                                                animateYearScrolling
                                                                className='medical-material-form__field material-form__label'
                                                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                                            />
                                                        </ThemeProvider>
                                                    </MuiPickersUtilsProvider>
                                                </Col>
                                                <Col md={4}>
                                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <ThemeProvider theme={defaultMaterialTheme}>
                                                            <KeyboardDatePicker
                                                                variant="inline"
                                                                value={dateWorldClose}
                                                                onChange={(date) => {
                                                                    setDateWorldClose(date);
                                                                }}
                                                                label="Fecha de Cierre Mundial"
                                                                format="yyyy/MM/DD"
                                                                animateYearScrolling
                                                                className='medical-material-form__field material-form__label'
                                                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                                            />
                                                        </ThemeProvider>
                                                    </MuiPickersUtilsProvider>
                                                </Col>

                                            </Row>
                                            <br />
                                            <br />
                                            <br />
                                            <br />

                                        </Container>
                                    </TabPane>
                                    <TabPane tabId="5">
                                        <Container>
                                            <Row>
                                                <Col md={3}>
                                                    <div className="form__form-group">
                                                        <span className="form__form-group-label">Aprobacion de Invima</span>
                                                        <div className="form__form-group-field">
                                                            <div className="form__form-group-field">
                                                                <Field
                                                                    name="aprobacion_invima_radio"
                                                                    component={renderRadioButtonField}
                                                                    label="Si"
                                                                    radioValue={true}
                                                                    defaultChecked={approveInvima == true ? true : false}
                                                                    value={approveInvima}
                                                                    onChange={(e) => {
                                                                        setApproveInvima(true)
                                                                    }}
                                                                />
                                                                <Field
                                                                    name="aprobacion_invima_radio"
                                                                    component={renderRadioButtonField}
                                                                    label="No"
                                                                    defaultChecked={approveInvima == false ? true : false}
                                                                    radioValue={false}
                                                                    value={approveInvima}
                                                                    onChange={(e) => {
                                                                        setApproveInvima(false)
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {approveInvima == null ? <b className="text-danger">La Aprobación del Invima es Requerida</b> : null}
                                                </Col>
                                                <Col md={3}>
                                                    <div className="form__form-group">
                                                        <span className="form__form-group-label">Medicamentos Prohibidos</span>
                                                        <div className="form__form-group-field">
                                                            <div className="form__form-group-field">
                                                                <Field
                                                                    name="forbidden_medicine_radio"
                                                                    component={renderRadioButtonField}
                                                                    label="Si"
                                                                    radioValue={true}

                                                                    defaultChecked={forbiddenMedicine == true ? true : false}
                                                                    value={forbiddenMedicine}
                                                                    onChange={(e) => {
                                                                        setForbidenMedicine(true)
                                                                    }}
                                                                />
                                                                <Field
                                                                    name="forbidden_medicine_radio"
                                                                    component={renderRadioButtonField}
                                                                    label="No"
                                                                    defaultChecked={forbiddenMedicine == false ? true : false}
                                                                    radioValue={false}
                                                                    value={forbiddenMedicine}
                                                                    onChange={(e) => {
                                                                        setForbidenMedicine(false)
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {forbiddenMedicine == null ? <b className="text-danger">Existencia de Medicamentos Prohibidos es Requerido</b> : null}
                                                </Col>
                                                <Col md={3}>
                                                    <div className="form__form-group">
                                                        <span className="form__form-group-label">Selección Miembro para Toma de Presión Arterial</span>
                                                        <div className="form__form-group-field">
                                                            <div className="form__form-group-field">
                                                                <Field
                                                                    name="select_member_arterial_radio"
                                                                    component={renderRadioButtonField}
                                                                    label="Si"
                                                                    radioValue={true}
                                                                    defaultChecked={selectMemberArterialPresion == true ? true : false}
                                                                    value={selectMemberArterialPresion}
                                                                    onChange={(e) => {
                                                                        setSelectMemberArterialPresion(true)
                                                                    }}
                                                                />
                                                                <Field
                                                                    name="select_member_arterial_radio"
                                                                    component={renderRadioButtonField}
                                                                    label="No"
                                                                    defaultChecked={selectMemberArterialPresion == false ? true : false}
                                                                    radioValue={false}
                                                                    value={selectMemberArterialPresion}
                                                                    onChange={(e) => {
                                                                        setSelectMemberArterialPresion(false)
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {selectMemberArterialPresion == null ? <b className="text-danger">Selección Miembro para Toma de Presion Arterial es Requerido</b> : null}
                                                </Col>
                                                <Col md={3}>
                                                    {/*Solo espacio*/}
                                                </Col>
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <Col md={3}>
                                                    <TextField
                                                        id="txtNumberPatientsSponsor"
                                                        label="Número Pacientes del Patrocinador"
                                                        value={numberPatientsSponsor}
                                                        type="number"
                                                        className='medical-material-form__field'
                                                        onChange={(event) => {
                                                            setNumberPatientsSponsor(event.target.value);
                                                        }}
                                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                                    >
                                                    </TextField>
                                                    {numberPatientsSponsor == "" ? <b className="text-danger">Número de Pacientes del Patrocinador es Requerido</b> : null}
                                                </Col>
                                                <Col md={3}>
                                                    <TextField
                                                        id="txtNumberPatientsCenter"
                                                        label="Número Pacientes Centro"
                                                        value={numberPatientsCenter}
                                                        type="number"
                                                        className='medical-material-form__field'
                                                        onChange={(event) => {
                                                            setNumberPatientsCenter(event.target.value);
                                                        }}
                                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                                    >
                                                    </TextField>
                                                    {numberPatientsCenter == "" ? <b className="text-danger">Número Pacientes Centro es Requerido</b> : null}
                                                </Col>
                                                <Col md={3}>
                                                    <TextField
                                                        id="txtNumberRandomVisits"
                                                        label="Número de Visitas Aleatorización"
                                                        value={numberRandomVisits}
                                                        type="number"
                                                        className='medical-material-form__field'
                                                        onChange={(event) => {
                                                            setNumberRandomVisits(event.target.value);
                                                        }}
                                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                                    >
                                                    </TextField>
                                                    {numberRandomVisits == "" ? <b className="text-danger">Número de Visitas Aleatorización es Requerido</b> : null}
                                                </Col>
                                                <Col md={3}>
                                                    <TextField
                                                        id="txtTimeTotalStudioMonths"
                                                        label="Tiempo total de Estudio (En Meses)"
                                                        value={timeTotalStudioMonths}
                                                        type="number"
                                                        className='medical-material-form__field'
                                                        onChange={(event) => {
                                                            setTimeTotalStudioMonths(event.target.value);
                                                        }}
                                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                                    >
                                                    </TextField>
                                                    {timeTotalStudioMonths == "" ? <b className="text-danger">Tiempo total de Estudio (En Meses) es Requerido</b> : null}
                                                </Col>
                                                <br /><br /><br /><br />
                                                <Col md={3}>
                                                    <TextField
                                                        id="select_state_studio"
                                                        select
                                                        label="Estado del Estudio"
                                                        value={stateStudio}
                                                        className='medical-material-form__field'
                                                        onChange={(event) => {
                                                            setStateStudio(event.target.value);
                                                        }}
                                                        disabled={true}

                                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                                    >
                                                        {stateStudioOpt.map((sta) => {
                                                            return <MenuItem key={sta.value} value={sta.value}>
                                                                {sta.label}
                                                            </MenuItem>
                                                        })}
                                                    </TextField>
                                                    {stateStudio == null ? <b className="text-danger">Estado del Estudio es Requerido</b> : null}
                                                </Col>
                                                <Col md={3}>
                                                    <TextField
                                                        label="Porcentaje de Retencion de Visitas"
                                                        value={retentionVisitsPercent}
                                                        onChange={(event) => {
                                                            setRetentionVisitsPercent(event.target.value);
                                                        }}
                                                        className='medical-material-form__field'
                                                        id="txtRententionVisitsPercent"
                                                        InputProps={{
                                                            inputComponent: PercentField
                                                        }}
                                                    />
                                                    {retentionVisitsPercent == "" ? <b className="text-danger">Porcentaje de Retencion de Visitas es Requerido</b> : null}
                                                </Col>

                                                <Col md={3}>
                                                    <TextField
                                                        label="Porcentaje de Gastos Generales"
                                                        value={generalExpendsPercent}
                                                        onChange={(event) => {
                                                            setGeneralExpendsPercent(event.target.value);
                                                        }}
                                                        className='medical-material-form__field'
                                                        id="txtGeneralExpendsFormat"
                                                        InputProps={{
                                                            inputComponent: PercentField
                                                        }}
                                                    />
                                                    {generalExpendsPercent == "" ? <b className="text-danger">Porcentaje de Gastos Generales es Requerido</b> : null}
                                                </Col>

                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                            </Row>
                                        </Container>
                                    </TabPane>
                                    <TabPane tabId="6">
                                        <Container>
                                            <Row>
                                                <Col md={12}>
                                                    <div className="form__form-group">
                                                        <span className="form__form-group-label">Requiere póliza de Responsabilidad</span>
                                                        <div className="form__form-group-field">
                                                            <div className="form__form-group-field">
                                                                <Field
                                                                    name="select_fiality_policy_require"
                                                                    component={renderRadioButtonField}
                                                                    label="Si"
                                                                    radioValue={true}
                                                                    value={liabityPolicyRequire}
                                                                    defaultChecked={liabityPolicyRequire}
                                                                    onChange={(e) => {
                                                                        setLiabityPolicyRequire(true)
                                                                    }}
                                                                />
                                                                <Field
                                                                    name="select_fiality_policy_require"
                                                                    component={renderRadioButtonField}
                                                                    label="No"
                                                                    radioValue={false}
                                                                    defaultChecked={true}
                                                                    value={liabityPolicyRequire}
                                                                    onChange={(e) => {
                                                                        setLiabityPolicyRequire(false)
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {liabityPolicyRequire == true ?
                                                        <div>
                                                            <Row>
                                                                <Col sm={12} md={6}>
                                                                    <TextField
                                                                        id="select_aseguradora"
                                                                        label="Compañia Aseguradora"
                                                                        select
                                                                        value={companyPolicy}
                                                                        className='medical-material-form__field'
                                                                        onChange={(event) => {
                                                                            setCompanyPolicy(event.target.value);
                                                                        }}

                                                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                                                    >
                                                                        {
                                                                            listCompanys.map((comp) => {
                                                                                return <MenuItem key={comp.id_aseguradora} value={comp}>
                                                                                    {comp.nombre}
                                                                                </MenuItem>
                                                                            })}
                                                                    </TextField>
                                                                </Col>
                                                                <Col sm={12} md={6}>
                                                                    <TextField
                                                                        id="txtNumPoliza"
                                                                        label="Número de Poliza"
                                                                        value={numPolicy}
                                                                        className='medical-material-form__field'
                                                                        onChange={(event) => {
                                                                            setNumPolicy(event.target.value);
                                                                        }}

                                                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                                                    >
                                                                    </TextField>
                                                                </Col>
                                                                <Col sm={12} md={6}>
                                                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                                                        <ThemeProvider theme={defaultMaterialTheme}>
                                                                            <KeyboardDatePicker
                                                                                variant="inline"
                                                                                value={dateStartPolicy}
                                                                                onChange={(date) => {
                                                                                    setDateStartPolicy(date);
                                                                                }}
                                                                                label="Desde"
                                                                                format="yyyy/MM/DD"
                                                                                animateYearScrolling
                                                                                className='medical-material-form__field material-form__label'
                                                                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                                                            />
                                                                        </ThemeProvider>
                                                                    </MuiPickersUtilsProvider>
                                                                </Col>
                                                                <Col sm={12} md={6}>
                                                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                                                        <ThemeProvider theme={defaultMaterialTheme}>
                                                                            <KeyboardDatePicker
                                                                                variant="inline"
                                                                                value={dateFinalPolicy}
                                                                                onChange={(date) => {
                                                                                    setDateFinalPolicy(date);
                                                                                }}
                                                                                label="Hasta"
                                                                                format="yyyy/MM/DD"
                                                                                animateYearScrolling
                                                                                className='medical-material-form__field material-form__label'
                                                                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                                                            />
                                                                        </ThemeProvider>
                                                                    </MuiPickersUtilsProvider>
                                                                </Col>
                                                                <Col sm={12} md={12}>
                                                                    <br />
                                                                    <input
                                                                        type="file"
                                                                        //value={documentPolicy}
                                                                        onChange={(e) => {
                                                                            setDocumentPolicy(e.target.files[0]);
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col sm={12} md={12}>
                                                                    <br />
                                                                    <Button className="btn btn-sm btn-success text-white" onClick={handleSubmitLiabilityPolicy}>
                                                                        +
                                                                    </Button>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col md={12}>
                                                                    <Table>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Compañia Aseguradora</th>
                                                                                <th>Número de Poliza</th>
                                                                                <th>Desde</th>
                                                                                <th>Hasta</th>
                                                                                <th>Documento</th>
                                                                                <th>Acciones</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {listPolicyLiability.map((policyLiability) => {
                                                                                return <tr>
                                                                                    <th>{policyLiability.company}</th>
                                                                                    <td>{policyLiability.num_policy}</td>
                                                                                    <td>{policyLiability.date_start_policy}</td>
                                                                                    <td>{policyLiability.date_final_policy}</td>
                                                                                    <td>
                                                                                        <a target="_blank" href={policyLiability.urlDocument}>
                                                                                            {policyLiability.documentName}
                                                                                        </a>
                                                                                    </td>
                                                                                    <td>
                                                                                        <IconButton
                                                                                            onClick={() => {
                                                                                                removePolicyLiability(policyLiability);
                                                                                            }}
                                                                                        >
                                                                                            <FontAwesomeIcon style={{ fontSize: 15 }} icon={faTrashAlt} />
                                                                                        </IconButton>
                                                                                    </td>
                                                                                </tr>
                                                                            })}
                                                                        </tbody>
                                                                    </Table>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        : null}
                                                    {liabityPolicyRequire == null ? <b className="text-danger">Requiere póliza de Responsabilidad</b> : null}
                                                </Col>
                                            </Row>
                                        </Container>
                                    </TabPane>
                                </TabContent>
                            </div>
                        </div>
                        <ButtonToolbar className="form__button-toolbar">
                            <Button color="primary" type="button"
                                onClick={() => validate()}>
                                Guardar
                            </Button>
                            <Button type="button"
                                onClick={() => history.goBack()}>
                                Cancelar
                            </Button>
                        </ButtonToolbar>
                    </CardBody>
                </Card>
            </div>

            <AlertModal
                color={colorAlertModal}
                title={colorAlertModal == "success" ? "Estudio Clinico Generado" : "Error del Sistema"}
                message={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => okModal()}
                toggle={() => setAlerShowModal(false)}
            />

            <Modal
                open={isLoading}
                onClose={() => {
                    setIsLoading(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '300x', width: '30%', margin: 10 }}>
                    <div className="text-center">
                        <br /><br /><br />
                        <div class="load__icon-wrap">
                            <svg class="load__icon">
                                <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                            </svg>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>
            </Modal>

        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_clinical_studio', // a unique identifier for this form
})(CreateClinicalStudio);